import api from './config';

// Función helper para convertir datos a FormData
const toFormData = (data) => {
  const formData = new FormData();
  
  Object.keys(data).forEach(key => {
    const value = data[key];
    
    // Si es un archivo (File object)
    if (value instanceof File) {
      formData.append(key, value);
    }
    // Si es una imagen base64, convertir a Blob
    else if (key === 'foto' && typeof value === 'string' && value.startsWith('data:image')) {
      // Extraer el base64 y tipo de imagen
      const matches = value.match(/^data:([^;]+);base64,(.+)$/);
      if (matches) {
        const mimeType = matches[1];
        const base64Data = matches[2];
        const byteCharacters = atob(base64Data);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: mimeType });
        const extension = mimeType.split('/')[1];
        formData.append('foto', blob, `photo.${extension}`);
      }
    }
    // Si es null o undefined, no agregar
    else if (value === null || value === undefined) {
      // No hacer nada
    }
    // Para valores booleanos, convertir a string
    else if (typeof value === 'boolean') {
      formData.append(key, value.toString());
    }
    // Para el resto de valores
    else {
      formData.append(key, value);
    }
  });
  
  return formData;
};

export const employeesAPI = {
  // Obtener todos los empleados
  getAll: async (params = {}) => {
    const response = await api.get('/employees', { params });
    return response.data;
  },

  // Obtener empleado por ID
  getById: async (id) => {
    const response = await api.get(`/employees/${id}`);
    return response.data;
  },

  // Crear nuevo empleado
  create: async (employeeData) => {
    const formData = toFormData(employeeData);
    const response = await api.post('/employees', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  // Actualizar empleado
  update: async (id, employeeData) => {
    const formData = toFormData(employeeData);
    const response = await api.put(`/employees/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  // Desactivar empleado (soft delete)
  delete: async (id) => {
    const response = await api.delete(`/employees/${id}`);
    return response.data;
  },

  // Buscar empleados
  search: async (searchTerm) => {
    const response = await api.get('/employees', {
      params: { search: searchTerm }
    });
    return response.data;
  },

  // Filtrar por departamento
  getByDepartment: async (departmentId) => {
    const response = await api.get('/employees', {
      params: { department_id: departmentId }
    });
    return response.data;
  },

  // Obtener por estado
  getByStatus: async (estado) => {
    const response = await api.get('/employees', {
      params: { estado }
    });
    return response.data;
  }
};
